/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Nav_SettingsInputs */

const en_seller_nav_settings = /** @type {(inputs: Seller_Nav_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

const es_seller_nav_settings = /** @type {(inputs: Seller_Nav_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración`)
};

const fr_seller_nav_settings = /** @type {(inputs: Seller_Nav_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres`)
};

const de_seller_nav_settings = /** @type {(inputs: Seller_Nav_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen`)
};

const ja_seller_nav_settings = /** @type {(inputs: Seller_Nav_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定`)
};

const zh_seller_nav_settings = /** @type {(inputs: Seller_Nav_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置`)
};

const ar_seller_nav_settings = /** @type {(inputs: Seller_Nav_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإعدادات`)
};

const id_seller_nav_settings = /** @type {(inputs: Seller_Nav_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengaturan`)
};

const it_seller_nav_settings = /** @type {(inputs: Seller_Nav_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni`)
};

const ru_seller_nav_settings = /** @type {(inputs: Seller_Nav_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки`)
};

const pt_seller_nav_settings = /** @type {(inputs: Seller_Nav_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações`)
};

const ko_seller_nav_settings = /** @type {(inputs: Seller_Nav_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설정`)
};

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Seller_Nav_SettingsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_nav_settings = /** @type {((inputs?: Seller_Nav_SettingsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Nav_SettingsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_nav_settings(inputs)
	if (locale === "es") return es_seller_nav_settings(inputs)
	if (locale === "fr") return fr_seller_nav_settings(inputs)
	if (locale === "de") return de_seller_nav_settings(inputs)
	if (locale === "ja") return ja_seller_nav_settings(inputs)
	if (locale === "zh") return zh_seller_nav_settings(inputs)
	if (locale === "ar") return ar_seller_nav_settings(inputs)
	if (locale === "id") return id_seller_nav_settings(inputs)
	if (locale === "it") return it_seller_nav_settings(inputs)
	if (locale === "ru") return ru_seller_nav_settings(inputs)
	if (locale === "pt") return pt_seller_nav_settings(inputs)
	return ko_seller_nav_settings(inputs)
});